export const generateEnhancePrompt = (businessContext) => {
  return `Phân tích và tăng cường chi tiết cho thông tin bối cảnh dưới đây với các yêu cầu sau:

- Bổ sung các thông tin quan trọng còn thiếu.
- Làm rõ mối quan hệ giữa các yếu tố và tác động của chúng.
- Thêm số liệu định lượng (nếu có thể) để minh họa.
- Sắp xếp nội dung theo cấu trúc logic, mạch lạc.
- Sử dụng ngôn ngữ chính xác, rõ ràng và chuyên nghiệp.

Bối cảnh kinh doanh hiện tại:
${businessContext}

Yêu cầu đầu ra:
- Giữ nguyên ý chính và thông tin cốt lõi.
- Mở rộng nội dung một cách hợp lý và đầy đủ.
- Đảm bảo độ dài phù hợp với mục tiêu.
- Trình bày trực tiếp nội dung, theo cấu trúc rõ ràng. Bỏ qua các chú thích và lời giới thiệu.
- Trình bày bằng tiếng Việt.
- Không sử dụng các từ ngữ phức tạp, khó hiểu.
- Không sử dụng markdown format.

Vui lòng cung cấp phiên bản đã được tăng cường chi tiết của bối cảnh kinh doanh trên.
`;
}; 